import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { submitStage } from './manorSlice';

/** "Rules" image button, top-right (img/Rules.png in the PHP stages). */
export function RulesButton({ onClick, className = '' }) {
  return (
    <button type="button" className={`manor-img-btn manor-rules-btn ${className}`} onClick={onClick} aria-label="Rules">
      <img src="/manor/img/Rules.png" alt="Rules" />
    </button>
  );
}

export function RulesModal({ rules, onClose }) {
  return (
    <div className="manor-modal-overlay" onClick={onClose}>
      <div className="manor-rules" style={{ backgroundImage: 'url(/manor/img/Rules_BG.jpg)' }} onClick={(e) => e.stopPropagation()}>
        <h2>RULES</h2>
        <ul>
          {rules.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
        <button type="button" className="manor-close-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

/**
 * Image-message popup with a cross; closing it is what submits the stage. The popup disappears the
 * moment the cross is pressed (the network call can take a second) and comes back if it fails.
 * onClose may return a promise resolving to false when the save failed.
 */
export function PopupMessage({ src, alt, width, onClose }) {
  const [closing, setClosing] = useState(false);
  const close = async () => {
    if (closing) return;
    setClosing(true);
    if ((await onClose()) === false) setClosing(false);
  };
  if (closing) return <div className="manor-popup-overlay" />; // keep the dim while saving

  return (
    <div className="manor-popup-overlay">
      <div className="manor-popup" style={width ? { width } : undefined}>
        <button type="button" className="manor-img-btn manor-popup-close" onClick={close} aria-label="Close">
          <img src="/manor/img/cross.png" alt="" />
        </button>
        <img src={src} alt={alt} />
      </div>
    </div>
  );
}

/**
 * Returns a `submit(points)` that records the stage once. On success the
 * ManorShell guard sees the new `nextStage` and routes on (or to the thank-you page).
 */
export function useStageSubmit(round) {
  const dispatch = useDispatch();
  const busy = useRef(false);
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);

  return async (points) => {
    if (busy.current) return true;
    busy.current = true;
    const res = await dispatch(submitStage({ round, points }));
    if (submitStage.rejected.match(res)) {
      busy.current = false;
      Swal.fire('', res.payload || 'Could not save your progress. Please try again.', 'error');
      return false;
    }
    return true;
  };
}
